import React, { Component } from 'react';
import ReactDOM from 'react-dom'
import  AutoResponsive  from 'autoresponsive-react'

export default class ResponsiveGrid extends Component {
  static propTypes = {

  };

  constructor(props) {
    super(props);
    const data = [
      {
        title: 'LOGO',
        size: 'half' 
      },
      {
        title: 'FORM',
        size: 'half' 
      },
      {
        title: 'WELLCOME TO ORIPANDO HOSTEL',
        size: 'half' 
      },
      {
        title: 'ROOMS & FACILITIES',
        size: 'half' 
      },
      {
        title: 'GRANADA & ALBAICIN',
        size: 'full' 
      },
      {
        title: 'BEERS',
        size: 'half' 
      },
      {
        title: 'FOOD & TAPAS',
        size: 'half' 
      },
      {
        title: 'SOCIAL MEDIA ',
        size: 'half' 
      },
      {
        title: 'SERVICES & FACILITIES',
        size: 'full' 
      },
      {
        title: 'LOCATION',
        size: 'full' 
      },
      {
        title: 'ADDRESS',
        size: 'half' 
      },
      {
        title: 'CONTACT US ',
        size: 'half' 
      },

    ]
    
    this.state = {
      itemMargin: 10,
      horizontalDirection: 'left',
      verticalDirection: 'top',
      containerHeight: null,
      data
    };
  }

  componentDidMount() {
    window.addEventListener('resize', () => {
      this.setState({
        containerWidth: ReactDOM.findDOMNode(this.refs.container).clientWidth
      });
    }, false);
  }

  getAutoResponsiveProps() {
    return {
      containerWidth: this.state.containerWidth || document.body.clientWidth,
      itemClassName: 'item',
      gridWidth: 100,
      horizontalDirection: this.state.horizontalDirection,
      verticalDirection: this.state.verticalDirection,
      itemMargin: this.state.itemMargin,
      containerWidth: this.state.containerWidth || this.props.containerWidth,
      itemClassName: 'item',
      containerHeight: this.state.containerHeight,
      transitionDuration: '.5',
      transitionTimingFunction: 'easeIn'
    };
  }

  getRandomColor() {
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }
  
  getSize(item){
    //if item is halfItem and the window is mobile 
    //take whole wiindow space otherwise take half
    // console.log("ITEM : " + item)
    const screenWidth = window.outerWidth
    // console.log("SIZE : " + screenWidth)
    // debugger;
    if(item.size == 'half' && screenWidth <= 768)//mobile 
    {
      return screenWidth;
    }else if (item.size == 'half' && screenWidth > 768) {
      return (screenWidth / 2);
    }
    return screenWidth 
  }

  render() {
    return (
      <div className="albumPanel">
      <AutoResponsive className="common-responsive-grid" ref="container" {...this.getAutoResponsiveProps()}>
      {
        this.state.data.map((i, index) => {
          let style = {
            width: this.getSize(i),
            height: i.title == 'LOGO' ? 300: this.getSize(i),
            backgroundColor: this.getRandomColor()
          };
          return (
            <div onClick={this.clickItemHandle} className="item" style={style}>{i.title}</div>
          );
        })
        
        // arrayList.map(function(i) {
        //   return <div onClick={this.clickItemHandle} className="item" style={this.state.styleList[i]}>{i}</div>;
        // }, this)
      }
    </AutoResponsive>
    </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/features/common/ResponsiveGrid.js